<div class="wab-pickup-type-picker">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 change-order-pickup-container">
      <div class="center-block pickup-method">
        <div aria-label="Change Your Pickup Method" role="radiogroup" class="form-group method-select">
          <b>Change Your Pickup Method</b>
          <p><strong>Please note - </strong>You may only change your pickup method once.</p>
          <hr aria-hidden="true">
          <div *ngFor="let pickupType of pickupTypes; let i = index" class="custom-radio-container">
            <div class="radio custom-sm-radio"
              [ngClass]="{'selectedRadio': pickupType && pickupMethodSet == pickupType.pickupType}">
              <input type="radio" name="pickuptype" id="{{pickupType?.idText}}" [(ngModel)]="pickupmethod"
                [value]=pickupType.pickupType (change)="pickUpMethodChange(pickupType.pickupType)" />
              <label for="{{pickupType?.idText}}">
                <span class="xs-icon" [ngClass]="getPickupTypeIconClass(pickupType.pickupType)">
                </span>{{getPickupTypeLabelText(pickupType.pickupType)}}</label>
            </div>
            <hr />
          </div>
        </div>
        <div class="button-container text-center">
          <button class="btn wb-btn-default" [disabled]="!pickupMethodSet" (click)="selectPickupType()">
            Set Pickup Method
          </button>
        </div>
      </div>
    </div>
  </div>
</div>